// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","content":"_2At5hr","imageWrapper":"_1xbZT0","fadeInFrames":"_1KvyaV"};